"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _Tooltip = _interopRequireDefault(require("../Tooltips/Tooltip"));
var _FieldParts = require("./FieldParts");
var _helpers = require("../helpers");
var _excluded = ["label", "labelFor", "labelAbove", "error", "showError", "children", "tooltipText", "inputFirst", "childrenWrapperProps", "forwardRef", "labelProps", "info", "automationHook", "w", "labelW", "inputW", "mB", "width", "inputWidth", "labelWidth", "marginBottom"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  children: _propTypes["default"].node,
  /** The error message that needs to be displayed, false otherwise */
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  /** Wether to display the error message when an error exists */
  showError: _propTypes["default"].bool,
  /** The label html "for" attribute */
  labelFor: _propTypes["default"].string,
  /**The label text */
  label: _propTypes["default"].string,
  /** The label width */
  labelW: _propTypes["default"].string,
  /** The input width - will be passed to the input & error wrapper when the label is NOT above */
  inputW: _propTypes["default"].string,
  /** Wether to display labelAbove */
  labelAbove: _propTypes["default"].bool,
  /** Width of the component */
  w: _propTypes["default"].string,
  /** The tooltip text */
  tooltipText: _propTypes["default"].string,
  /** input label in first line, error in second line */
  inputFirst: _propTypes["default"].bool,
  /** An object for any additional props to be passed to the wrapper around children. The wrapper extends a Flex component */
  childrenWrapperProps: _propTypes["default"].object,
  /** The ref forwarded to the grid */
  forwardRef: _propTypes["default"].any,
  /** Props for the label. If user decides to pass `w` for the label width, but they also pass `labelW`, the `labelW` will overwrite this `labelProps.w`  */
  labelProps: _propTypes["default"].object,
  /** Adds a margin bottom after the field */
  mB: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string,
  /** The info text below the input */
  info: _propTypes["default"].string,
  /** DEPRECATED: Use "labelW" instead */
  labelWidth: _propTypes["default"].string,
  /** DEPRECATED: Use "inputW" instead */
  inputWidth: _propTypes["default"].string,
  /** DEPRECATED: Use "w" instead */
  width: _propTypes["default"].string,
  /** DEPRECATED: Adds a margin bottom after the field  */
  marginBottom: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string])
};
var templateAreas = {
  areaLabelAboveInput: function areaLabelAboveInput(withError, withInfo) {
    return (/** with error */
      withError ? withInfo ? "\n        \"label\"\n        \"input\"\n        \"info\"\n        \"error\"\n      " : "\n        \"label\"\n        \"input\"\n        \"error\"\n      " : /** without error */
      withInfo ? "\n    \"label\"\n    \"input\"\n    \"info\"\n  " : "\n    \"label\"\n    \"input\"\n  "
    );
  },
  areaLabelInput: function areaLabelInput(withError, withInfo) {
    return (/** with error */
      withError ? withInfo ? "\n        \"label input\"\n        \"  .   info\"\n        \"  .   error\"\n      " : "\n        \"label input\"\n        \"  .   error\"" : /** without error */
      withInfo ? "\n    \"label input\"\n    \"  .   info\"\n  " : "\n    \"label input\"\n  "
    );
  },
  areaInputLabel: function areaInputLabel(withError, withInfo) {
    return withError ? withInfo ? "\n        \"input label\"\n        \"info    .  \"\n        \"error error\"\n      " : "\n        \"input label\"\n        \"error error\"\n      " : /** without error */
    withInfo ? "\n    \"input label\"\n    \"info  info\"\n  " : "\n    \"input label\"\n  ";
  },
  areaInput: function areaInput(withError, withInfo) {
    return withError ? withInfo ? "\n        \"input\"\n        \"info\"\n        \"error\"\n      " : "\n        \"input\"\n        \"error\"\n      " : /** without error */
    withInfo ? "\n    \"input\"\n    \"info\"\n  " : "\n    \"input\"\n  ";
  }
};
var getTemplateArea = function getTemplateArea(templateAreaName, hasError, info) {
  var _templateAreas$templa;
  return (_templateAreas$templa = templateAreas[templateAreaName]) === null || _templateAreas$templa === void 0 ? void 0 : _templateAreas$templa.call(templateAreas, hasError, info);
};
var Grid = _styledComponents["default"].div.attrs(function (props) {
  return {
    mB: props.mB,
    inputW: props.inputW || props.inputWidth,
    labelW: props.labelW || props.labelWidth,
    w: props.w || props.width
  };
}).withConfig({
  displayName: "FieldWrapper__Grid",
  componentId: "sc-ntbsqo-0"
})(["display:grid;grid-template-areas:", ";gap:", " ", ";width:", ";height:", ";", ";", ";", ";", ";"], function (props) {
  return getTemplateArea(props.templateAreas, props.hasError, props.info);
}, function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.spaces.s;
}, function (props) {
  return props.w || "auto";
}, function (props) {
  return props.height || "auto";
}, function (props) {
  return props.templateAreas === "areaInputLabel" && (0, _styledComponents.css)(["", ""], (props.inputW || props.labelW) && (0, _styledComponents.css)(["grid-template-columns:", " ", ";"], props.inputW || "1fr", props.labelW || "1fr"));
}, function (props) {
  return props.templateAreas === "areaLabelInput" && (0, _styledComponents.css)(["", ""], (props.inputW || props.labelW) && (0, _styledComponents.css)(["grid-template-columns:", " ", ";"], props.labelW || "1fr", props.inputW || "1fr"));
}, function (props) {
  return props.templateAreas === "areaInput" && (0, _styledComponents.css)(["", ""], props.inputW && (0, _styledComponents.css)(["grid-template-columns:", ";"], props.inputW));
}, function (props) {
  return props.mB && (0, _styledComponents.css)(["margin-bottom:", ";"], props.mB === true ? props.theme.fields.mB : (0, _helpers.getSpace)(props, "mB", "base"));
});
var LabelArea = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapper__LabelArea",
  componentId: "sc-ntbsqo-1"
})(["grid-area:label;"]);
var InputArea = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapper__InputArea",
  componentId: "sc-ntbsqo-2"
})(["grid-area:input;display:flex;align-items:center;"]);
var ErrorArea = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapper__ErrorArea",
  componentId: "sc-ntbsqo-3"
})(["grid-area:error;"]);
var InfoArea = _styledComponents["default"].div.withConfig({
  displayName: "FieldWrapper__InfoArea",
  componentId: "sc-ntbsqo-4"
})(["grid-area:info;"]);
var FieldWrapper = function FieldWrapper(_ref) {
  var _ref2, _ref3;
  var label = _ref.label,
    labelFor = _ref.labelFor,
    labelAbove = _ref.labelAbove,
    error = _ref.error,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? true : _ref$showError,
    children = _ref.children,
    _ref$tooltipText = _ref.tooltipText,
    tooltipText = _ref$tooltipText === void 0 ? "" : _ref$tooltipText,
    _ref$inputFirst = _ref.inputFirst,
    inputFirst = _ref$inputFirst === void 0 ? false : _ref$inputFirst,
    childrenWrapperProps = _ref.childrenWrapperProps,
    forwardRef = _ref.forwardRef,
    labelProps = _ref.labelProps,
    info = _ref.info,
    automationHook = _ref.automationHook,
    w = _ref.w,
    labelW = _ref.labelW,
    inputW = _ref.inputW,
    mB = _ref.mB,
    width = _ref.width,
    inputWidth = _ref.inputWidth,
    labelWidth = _ref.labelWidth,
    marginBottom = _ref.marginBottom,
    rest = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    width: width,
    inputWidth: inputWidth,
    labelWidth: labelWidth,
    marginBottom: marginBottom
  }, "FieldWrapper");
  var theme = (0, _styledComponents.useTheme)();
  var labelAboveProp = labelAbove !== undefined ? labelAbove : theme.fields.labelAbove;
  var templateAreas = "areaLabelInput";
  if (labelAboveProp) {
    templateAreas = "areaLabelAboveInput";
  }
  if (inputFirst) {
    templateAreas = "areaInputLabel";
  }
  if (!label) {
    templateAreas = "areaInput";
  }
  return /*#__PURE__*/_react["default"].createElement(Grid, _extends({
    w: w !== null && w !== void 0 ? w : width,
    inputW: inputW !== null && inputW !== void 0 ? inputW : inputWidth,
    labelW: (_ref2 = labelW || (labelProps === null || labelProps === void 0 ? void 0 : labelProps.w)) !== null && _ref2 !== void 0 ? _ref2 : labelWidth,
    templateAreas: templateAreas,
    hasError: !!error,
    ref: forwardRef,
    mB: mB !== null && mB !== void 0 ? mB : marginBottom,
    info: info
  }, rest), !!label && /*#__PURE__*/_react["default"].createElement(LabelArea, null, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    tooltipText: tooltipText,
    align: labelAbove || !labelAbove && inputFirst ? "start" : "center",
    gap: labelAbove ? "xxs" : "_xs"
  }, /*#__PURE__*/_react["default"].createElement(_FieldParts.Label, _extends({
    hasError: error,
    above: labelAboveProp
  }, labelProps, {
    w: (_ref3 = labelW || (labelProps === null || labelProps === void 0 ? void 0 : labelProps.w)) !== null && _ref3 !== void 0 ? _ref3 : labelWidth,
    htmlFor: labelFor
  }, (0, _automationHooks.hook)(automationHook, "field-label")), label))), /*#__PURE__*/_react["default"].createElement(InputArea, null, /*#__PURE__*/_react["default"].createElement(_Box["default"], _extends({
    d: "flex",
    wrap: "wrap",
    w: "100%",
    gap: "xs"
  }, childrenWrapperProps), children)), info && /*#__PURE__*/_react["default"].createElement(InfoArea, null, /*#__PURE__*/_react["default"].createElement(_FieldParts.Info, (0, _automationHooks.hook)(automationHook, "field-info"), info)), showError && error && /*#__PURE__*/_react["default"].createElement(ErrorArea, null, /*#__PURE__*/_react["default"].createElement(_FieldParts.Error, (0, _automationHooks.hook)(automationHook, "field-error"), error)));
};
FieldWrapper.propTypes = propTypes;
var _default = FieldWrapper;
exports["default"] = _default;